// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Circle_green.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*General start*/
.radio_buttons{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
    height: 30px;
}

.check_boxes-checks{
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 1rem;
    border-radius: 0px;
}

.forms-form-col{
    text-align: left;
    margin-top: 0.5rem;
}

.feedback_row{
    margin-top: 1rem;
}

.input_group{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.inputs input{
    min-width: 210px;
    height: 40px;
}

.form_row{
    display: flex;
    flex-direction: row;
    gap: 4rem;
    text-align: left;
}

.form_row input{
    max-width: 400px;
    display: block;
}

/* input{
    height: 2rem;
    margin-top: 1rem;
    border-radius: 0px;
} */


.form-check-input{
    border-radius: 0px;
}

.check_boxes{
    width: 100%;
    font-weight: 400;
    padding-top: 1rem;
    display: flex;
    gap: 2rem;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.forms-invalid{
    border: 2px solid red; 
    background-color: #ffeeee;
    color: red; 
}
/*General end*/

/* Mentoring form start*/

.forms-mentoring_form{
    border: 5px solid #fff;
    box-shadow:rgba(0, 0, 0, 0.25) 0px 11px 20px, rgba(0, 0, 0, 0.12) 0px -8px 15px, rgba(0, 0, 0, 0.12) 0px 1px 4px, rgba(0, 0, 0, 0.17) 0px -4px 8px, rgba(0, 0, 0, 0.09) 0px -2px 3px;
    /* background-color: #3AC9B5; */
    background-color: var(--main-green-color);
    padding: 2rem;
    font-weight: 600;
    border-radius: 0px;
}

.forms-mentoring_form input{
    /* margin-top: 1rem; */
    border-radius: 0px;
}


/* Mentoring form end*/

/* Feedback form start*/

.forms-feedback_form{
    border: 5px solid #fff;
    box-shadow:rgba(0, 0, 0, 0.25) 0px 11px 20px, rgba(0, 0, 0, 0.12) 0px -8px 15px, rgba(0, 0, 0, 0.12) 0px 1px 4px, rgba(0, 0, 0, 0.17) 0px -4px 8px, rgba(0, 0, 0, 0.09) 0px -2px 3px;
    /* background-color: #3AC9B5; */
    background-color: var(--main-green-color);
    padding: 2rem;
    font-weight: 600;
    border-radius: 0px;
    width: 100% !important;
}
.forms-feedback_form input{
    border-radius: 0px;
}
/* Feedback form end*/

/*Support form start*/
.forms-support_header{
    padding: 0 auto;
}

.forms-support_header p{
    float: inherit;
    text-align: left;
    
}

.forms-support_header-green{
    margin-top: 2rem;
    /* color: #3AC9B5; */
    color: var(--main-green-color);
    text-align: left;
    font-size: 18px;
    font-weight: 800;
}

.forms_red_star{
    color: red;
    margin-left: 5px;
}

.forms_small{
    font-weight: 200;
}

.form-check-input{
    border-radius: 0px !important;
}

.forms_main_header{
    text-align: center;
    margin: 3rem auto;
}

.forms_label{
    margin-bottom: 0.6rem;
    margin-left: 0.6rem;
}

.form-control{
    margin-top: 0;
    
}

#castom_check, #castom_check0, 
#castom_check1, #castom_check2, 
#castom_check3, #castom_check4, 
#castom_check5{
    border-radius: 10px !important;
}

#castom_check:checked,
#castom_check0:checked,
#castom_check1:checked, 
#castom_check2:checked,
#castom_check3:checked,
#castom_check4:checked,
#castom_check5:checked{
    border: 0px;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size:0.7rem;
    border-radius: 10px !important;
   
}

#castom_check1{
    border-radius: 10px !important;
}

#castom_check1:checked{
    border: 0px;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size:0.7rem;
    border-radius: 10px !important;
   
}

#castom_check_green:checked{
    background-color: #fff;
    border-color: #E5E8EC;
    background-size:0.7rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

#castom_check_green_sw-material:checked,
#castom_check_green:checked, #castom_check_green1:checked,
#castom_check_green2:checked, #castom_check_green3:checked,
#castom_check_green0:checked{
    background-color: #3AC9B5;
    border: 0;
    /* background-image: url('/public/images/Circle.png'); */
}

#castom_check_green_sw-legal:checked{
    background-color: #3AC9B5;
    border: 0;
    /* background-image: url('/public/images/Circle.png'); */
}

#castom_check_green_sw-psyco:checked{
    background-color: #3AC9B5;
    border: 0;
    /* background-image: url('/public/images/Circle.png'); */
}


input[type="checkbox"],
input[type="radio"] {
    cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/forms.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;GAIG;;;AAGH;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;AACd;AACA,cAAc;;AAEd,wBAAwB;;AAExB;IACI,sBAAsB;IACtB,oLAAoL;IACpL,+BAA+B;IAC/B,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA,sBAAsB;;AAEtB,uBAAuB;;AAEvB;IACI,sBAAsB;IACtB,oLAAoL;IACpL,+BAA+B;IAC/B,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA,qBAAqB;;AAErB,qBAAqB;AACrB;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;;;;IAII,8BAA8B;AAClC;;AAEA;;;;;;;IAOI,WAAW;IACX,sBAAsB;IACtB,yDAAwD;IACxD,sBAAsB;IACtB,8BAA8B;;AAElC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,yDAAwD;IACxD,sBAAsB;IACtB,8BAA8B;;AAElC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,yDAAwD;AAC5D;;AAEA;;;;IAII,yBAAyB;IACzB,SAAS;IACT,wDAAwD;AAC5D;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,wDAAwD;AAC5D;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,wDAAwD;AAC5D;;;AAGA;;IAEI,0BAA0B;AAC9B","sourcesContent":["/*General start*/\n.radio_buttons{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 2rem;\n    height: 30px;\n}\n\n.check_boxes-checks{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 1rem;\n    border-radius: 0px;\n}\n\n.forms-form-col{\n    text-align: left;\n    margin-top: 0.5rem;\n}\n\n.feedback_row{\n    margin-top: 1rem;\n}\n\n.input_group{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.inputs input{\n    min-width: 210px;\n    height: 40px;\n}\n\n.form_row{\n    display: flex;\n    flex-direction: row;\n    gap: 4rem;\n    text-align: left;\n}\n\n.form_row input{\n    max-width: 400px;\n    display: block;\n}\n\n/* input{\n    height: 2rem;\n    margin-top: 1rem;\n    border-radius: 0px;\n} */\n\n\n.form-check-input{\n    border-radius: 0px;\n}\n\n.check_boxes{\n    width: 100%;\n    font-weight: 400;\n    padding-top: 1rem;\n    display: flex;\n    gap: 2rem;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.forms-invalid{\n    border: 2px solid red; \n    background-color: #ffeeee;\n    color: red; \n}\n/*General end*/\n\n/* Mentoring form start*/\n\n.forms-mentoring_form{\n    border: 5px solid #fff;\n    box-shadow:rgba(0, 0, 0, 0.25) 0px 11px 20px, rgba(0, 0, 0, 0.12) 0px -8px 15px, rgba(0, 0, 0, 0.12) 0px 1px 4px, rgba(0, 0, 0, 0.17) 0px -4px 8px, rgba(0, 0, 0, 0.09) 0px -2px 3px;\n    /* background-color: #3AC9B5; */\n    background-color: var(--main-green-color);\n    padding: 2rem;\n    font-weight: 600;\n    border-radius: 0px;\n}\n\n.forms-mentoring_form input{\n    /* margin-top: 1rem; */\n    border-radius: 0px;\n}\n\n\n/* Mentoring form end*/\n\n/* Feedback form start*/\n\n.forms-feedback_form{\n    border: 5px solid #fff;\n    box-shadow:rgba(0, 0, 0, 0.25) 0px 11px 20px, rgba(0, 0, 0, 0.12) 0px -8px 15px, rgba(0, 0, 0, 0.12) 0px 1px 4px, rgba(0, 0, 0, 0.17) 0px -4px 8px, rgba(0, 0, 0, 0.09) 0px -2px 3px;\n    /* background-color: #3AC9B5; */\n    background-color: var(--main-green-color);\n    padding: 2rem;\n    font-weight: 600;\n    border-radius: 0px;\n    width: 100% !important;\n}\n.forms-feedback_form input{\n    border-radius: 0px;\n}\n/* Feedback form end*/\n\n/*Support form start*/\n.forms-support_header{\n    padding: 0 auto;\n}\n\n.forms-support_header p{\n    float: inherit;\n    text-align: left;\n    \n}\n\n.forms-support_header-green{\n    margin-top: 2rem;\n    /* color: #3AC9B5; */\n    color: var(--main-green-color);\n    text-align: left;\n    font-size: 18px;\n    font-weight: 800;\n}\n\n.forms_red_star{\n    color: red;\n    margin-left: 5px;\n}\n\n.forms_small{\n    font-weight: 200;\n}\n\n.form-check-input{\n    border-radius: 0px !important;\n}\n\n.forms_main_header{\n    text-align: center;\n    margin: 3rem auto;\n}\n\n.forms_label{\n    margin-bottom: 0.6rem;\n    margin-left: 0.6rem;\n}\n\n.form-control{\n    margin-top: 0;\n    \n}\n\n#castom_check, #castom_check0, \n#castom_check1, #castom_check2, \n#castom_check3, #castom_check4, \n#castom_check5{\n    border-radius: 10px !important;\n}\n\n#castom_check:checked,\n#castom_check0:checked,\n#castom_check1:checked, \n#castom_check2:checked,\n#castom_check3:checked,\n#castom_check4:checked,\n#castom_check5:checked{\n    border: 0px;\n    background-color: #fff;\n    background-image: url('/public/images/Circle_green.png');\n    background-size:0.7rem;\n    border-radius: 10px !important;\n   \n}\n\n#castom_check1{\n    border-radius: 10px !important;\n}\n\n#castom_check1:checked{\n    border: 0px;\n    background-color: #fff;\n    background-image: url('/public/images/Circle_green.png');\n    background-size:0.7rem;\n    border-radius: 10px !important;\n   \n}\n\n#castom_check_green:checked{\n    background-color: #fff;\n    border-color: #E5E8EC;\n    background-size:0.7rem;\n    background-image: url('/public/images/Circle_green.png');\n}\n\n#castom_check_green_sw-material:checked,\n#castom_check_green:checked, #castom_check_green1:checked,\n#castom_check_green2:checked, #castom_check_green3:checked,\n#castom_check_green0:checked{\n    background-color: #3AC9B5;\n    border: 0;\n    /* background-image: url('/public/images/Circle.png'); */\n}\n\n#castom_check_green_sw-legal:checked{\n    background-color: #3AC9B5;\n    border: 0;\n    /* background-image: url('/public/images/Circle.png'); */\n}\n\n#castom_check_green_sw-psyco:checked{\n    background-color: #3AC9B5;\n    border: 0;\n    /* background-image: url('/public/images/Circle.png'); */\n}\n\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    cursor: pointer !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
